import { attr, customElement, FASTElement, observable } from '@microsoft/fast-element';
import { TileCardTemplate as template } from './tile-card.template';
import { TileCardStyles as styles } from './tile-card.styles';

const name = 'tile-card';

@customElement({
  name,
  template,
  styles,
})
export class TileCard extends FASTElement {
  @attr @observable title;
  @attr @observable tooltip;
  @attr({ mode: 'boolean' }) inline: boolean = false;
}
